import type { PlayableKey } from "../../domain/training/missions";
import type {
  ProgressRow,
  TrainingStatus,
} from "../../domain/training/progress";

export type TrainingErrorCode =
  | "forbidden"
  | "invalid_mission"
  | "invalid_score"
  | "unknown";

export class TrainingApiError extends Error {
  constructor(public code: TrainingErrorCode) {
    super(code);
    this.name = "TrainingApiError";
  }
}

/** /formation data. Supabase: my_training_status / team_training_status / record_training_attempt (46_, product keys 107_). */
export interface TrainingApi {
  /** The signed-in rep's progress and field mission counts. */
  myStatus(): Promise<TrainingStatus>;
  /** Every active user (admins only; others get `forbidden`). */
  teamStatus(): Promise<TrainingStatus[]>;
  /** One attempt at a game mission (attempts + 1, best score kept). Returns the stored row. */
  recordAttempt(key: PlayableKey, score: number): Promise<ProgressRow>;
}
